var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"main"},[_c('keep-alive',{attrs:{"include":"index"}},[_c('router-view',{attrs:{"index":_vm.tabs_index}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }